export default __webpack_public_path__ + "static/media/dolphin_approach.adc4c597.svg";